import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { FilterBox } from '@/src/components/common/FilterBox/FilterBox';

type ItemProps = {
  column: string;
  label: string;
  sortingType: string;
  disableFilters?: boolean;
};

const Item = ({ column, label, sortingType, disableFilters }: ItemProps) => {
  const files = useSelector((state: any) => state.files);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onUpdateSorting = useCallback(
    (order: string) => {
      dispatch({
        type: 'UPDATE_FILES_SORTING',
        sorting: {
          column,
          order,
        },
      });
    },
    [dispatch, column]
  );

  const isAsc = files.sorting.column === column && files.sorting.order === 'asc';
  const isDesc = files.sorting.column === column && files.sorting.order === 'desc';

  return (
    <>
      <div className="columnItemContainer">
        {!disableFilters ? (
          <a
            onClick={handleClick}
            className={`filterTrigger ${isAsc || isDesc ? 'hasSorting' : ''} ${
              open ? 'active' : ''
            }`}
          >
            {(isAsc || isDesc) && (
              <i className="material-icons iconAscDesc">
                {isDesc ? 'arrow_downward' : 'arrow_upward'}
              </i>
            )}
            <span>{label}</span>
            <div className="filterIcon">
              <i className="material-icons">filter_list</i>
            </div>
          </a>
        ) : (
          <div className="filterTrigger" style={{ cursor: 'initial' }}>
            <span>{label}</span>
          </div>
        )}
      </div>

      {!disableFilters && (
        <Popper open={open} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: 100 }}>
          <ClickAwayListener onClickAway={handleClose}>
            <FilterBox
              classes={{ options: '' }}
              column={column}
              sortingType={sortingType}
              sortingSelected={files.sorting}
              onUpdateSorting={onUpdateSorting}
              hideFilterSection={true}
            />
          </ClickAwayListener>
        </Popper>
      )}
    </>
  );
};

export default Item;
